<script>
  import { domainName, record } from '../stores.js';
  import ContactUsForm from '../ContactUsForm.svelte';

  let createBimi = false;
</script>

<div class="record-box record-404 text-center">
  <div id="headingRaw" class="box-label text-center">
    <h5 class="mb-3">No BIMI record found for <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <p>This domain does not have a TXT record published.</p>
    <button on:click|preventDefault={() => createBimi = true} disabled={createBimi} class="btn btn-1" id="create-bimi">Create BIMI Record</button>
  </div>
  {#if createBimi}
    <div class="box-detail found-no-record">
      <ContactUsForm />
    </div>
  {/if}
</div>

<style>

</style>
